<template>
  <div v-if="!$store.loading">
    <b-row>
      <b-col md="3">
        <b-form-input v-model="searchFilter" :placeholder="$t('recherche_label')" size="sm"></b-form-input>
      </b-col>
      <b-col md="3">
        <b-form-select v-model="courseFilter" :options="participants.list_courses" @input="$store.state.selected_live_course = courseFilter" size="sm"></b-form-select>
      </b-col>
      <b-col md="2" style="text-align: left">
        <b-button-group>
          <b-button size="sm" class="sex_select_button" v-on:click="sexeFilter = ''" v-bind:class="{ sex_selected_button: sexeFilter === '' }">
            <v-icon name="male" />
            <v-icon name="female" />
          </b-button>
          <b-button size="sm" class="sex_select_button" v-on:click="sexeFilter = 'M'" v-bind:class="{ sex_selected_button: sexeFilter === 'M' }">
            <v-icon name="male" />
          </b-button>
          <b-button size="sm" class="sex_select_button" v-on:click="sexeFilter = 'F'" v-bind:class="{ sex_selected_button: sexeFilter === 'F' }">
            <v-icon name="female" />
          </b-button>
        </b-button-group>
      </b-col>
      <b-col md="4">
        <b-pagination v-model="page" :total-rows="participants.nb_inscriptions" :per-page="perPage" aria-controls="table_participants"></b-pagination>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="8">
        <p style="text-align: left">
          <b v-if="courseFilter != 'Hors course' && participants.list_parcours && participants.list_parcours[courseFilter] && participants.list_parcours[courseFilter].metadata.heure_depart != 'prévu à '"
            >Départ
            {{ participants.list_parcours[courseFilter].metadata.heure_depart }}
            | </b
          ><b>{{ translated_stats }}</b>
        </p>
      </b-col>
      <b-col md="4">
        <p class="count-table">
          {{ (page - 1) * perPage }} {{ $t("splitter_pagination") }} <span v-if="page * perPage < participants.nb_inscriptions">{{ page * perPage }}</span
          ><span v-else>{{ participants.nb_inscriptions }}</span> /
          {{ participants.nb_inscriptions }}
        </p></b-col
      >
    </b-row>
    <b-table style="margin-top: 10px" id="table_participants" responsive small hover :tbody-tr-class="row_femme" :items="participants.list_participants" :fields="fields" :per-page="perPage" @row-clicked="openFicheCoureur">
      <template #head(classement)>
        <b-button style="white-space: nowrap" size="sm" class="live_filter_btn_header_row" v-on:click="sortby = 'clt'" v-bind:class="{ sex_selected_button: sortby === 'clt' }"> <b-icon icon="sort-numeric-down"></b-icon> {{ $t("clt") }} </b-button>
      </template>
      <template #head(nom)>
        <b-button style="white-space: nowrap" size="sm" class="live_filter_btn_header_row" v-on:click="sortby = 'name'" v-bind:class="{ sex_selected_button: sortby === 'name' }"> <b-icon icon="sort-alpha-down"></b-icon> {{ $t("nom") }} </b-button>
      </template>
      <template #head(itra)>
        <p style="min-width: 80px">
          <b-button style="white-space: nowrap; height: 100% !important" size="sm" class="live_filter_btn_header_row itra_filter_btn" v-on:click="sortby = 'itra'" v-bind:class="{ sex_selected_button: sortby === 'itra' }">
            <b-icon icon="sort-numeric-down"></b-icon> <img src="../../../assets/Logo_itra_Simple_N blanc.png" alt="itra" class="itra_logo_filter" />
          </b-button>
        </p>
      </template>
      <template #cell(classement)="row">
        <span v-if="row.item.classement != 100000">{{ row.item.classement }}</span>
        <span v-else>-</span>
      </template>

      <template #cell(classement_cat)="row">
        <span v-if="row.item.classement_cat != 100000">{{ row.item.classement_cat }}{{ row.item.cat }}</span>
        <span v-else>-</span>
      </template>
      <template #cell(classement_sexe)="row">
        <span v-if="row.item.classement_sexe != 100000">{{ row.item.classement_sexe }}{{ row.item.sexe }}</span>
        <span v-else>-</span>
      </template>
      <template #cell(itra)="row">
        <span v-if="row.item.itra > 0">{{ row.item.itra }}</span>
        <span v-else>-</span>
      </template>
      <template #cell(sexe)="row">
        <p class="sexe-icon-male" v-if="row.item.sexe === 'M'">M</p>
        <p class="sexe-icon-female" v-else-if="row.item.sexe === 'F'">F</p>
        <p class="sexe-icon-mixte" v-else>M/F</p>
      </template>
      <template #cell(nom)="row">
        <span><img class="flag" :src="'https://sportips.fr/live/img/Flags/' + row.item.nation + '.jpg'" />{{ row.item.nom }} {{ row.item.prenom }}</span>
      </template>
      <template #cell(heure_depart_coureur)="row">
        <p>
          <span v-if="row.item.heure_depart_coureur != ''">{{ row.item.heure_depart_coureur }}</span
          ><span v-else>-</span>
        </p>
      </template>
      <template #cell(abandon)="row">
        <b-form-checkbox size="sm" v-model="row.item.abandon" @change="changeCoureurAbandon(row.item)" value="O" unchecked-value="N"></b-form-checkbox>
      </template>
      <template #cell(disqualifie)="row">
        <b-form-checkbox size="sm" v-model="row.item.disqualifie" @change="changeCoureurDisqualifie(row.item)" value="O" unchecked-value="N"></b-form-checkbox>
      </template>
      <template #cell(statut)="row">
        <div class="live_status">
          <p v-if="row.item.statut.text.includes('Arrivé')" class="text-nowrap status_arrive">
            <v-icon name="check" />
            {{ get_translated_status(row.item.statut.text) }}
          </p>
          <p v-else-if="row.item.statut.text.includes('Abandon') || row.item.statut.text.includes('Disqualifié') || row.item.statut.text.includes('Non parti')" class="text-nowrap status_abandon">
            <v-icon name="times" />
            {{ get_translated_status(row.item.statut.text) }}
          </p>
          <p v-else class="text-nowrap status_autre">
            {{ get_translated_status(row.item.statut.text) }}
          </p>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      participants: {},
      searched_participants: [],
      courseFilter: "",
      searchFilter: "",
      sexeFilter: "",
      sortby: "clt",
      page: 1,
      perPage: 30,
      updateIn: 10,

      fields: [
        {
          key: "classement",
          sortable: false,
          label: this.$t("scratch"),
        },
        {
          key: "dossard",
          sortable: false,
          label: this.$t("dossard"),
        },
        {
          key: "itra",
          sortable: false,
          label: "Itra",
        },
        {
          key: "nom",
          sortable: false,
          label: this.$t("nom_prenom"),
        },
        {
          key: "sexe",
          sortable: false,
          label: this.$t("sexe"),
        },
        {
          key: "cat",
          sortable: false,
          label: "Cat",
        },
        {
          key: "club",
          sortable: false,
          label: this.$t("club"),
        },
        {
          key: "classement_sexe",
          sortable: false,
          label: this.$t("clt_sexe"),
        },
        {
          key: "classement_cat",
          sortable: false,
          label: this.$t("clt_cat"),
        },
        {
          key: "statut",
          sortable: false,
          label: this.$t("statut"),
          class: "align_center",
        },
      ],
    };
  },
  watch: {
    page() {
      this.fetchInscriptions();
    },
    sortby() {
      this.page = 1;
      this.fetchInscriptions();
    },
    courseFilter() {
      this.page = 1;
      this.fetchInscriptions();
    },

    searchFilter() {
      this.page = 1;
      this.fetchInscriptions();
    },
    sexeFilter() {
      this.page = 1;
      this.fetchInscriptions();
    },
  },
  computed: {
    translated_stats() {
      var translated_stats = "";
      if (this.participants.stats_inscriptions) {
        var raw_stats = this.participants.stats_inscriptions.split("-");
        for (var i = 0; i < raw_stats.length; i++) {
          var raw_item_stat = raw_stats[i].split(":");
          if (raw_item_stat[0].includes("Inscrits")) {
            raw_item_stat[0] = this.$t("inscrits");
          } else if (raw_item_stat[0].includes("Partis")) {
            raw_item_stat[0] = this.$t("partis");
          } else if (raw_item_stat[0].includes("Arrivés")) {
            raw_item_stat[0] = this.$t("arrives");
          } else if (raw_item_stat[0].includes("Abandons")) {
            raw_item_stat[0] = this.$t("abandons");
          }
          translated_stats += raw_item_stat[0] + " : " + raw_item_stat[1];
          if (i < raw_stats.length - 1) {
            translated_stats += " - ";
          }
        }
      }
      return translated_stats;
    },
  },
  methods: {
    // Methode spécifique au PC course pour changer le statut d'abandon d'un coureur
    changeCoureurAbandon(coureur) {
      let _this = this;
      let data = {
        id_module: this.$store.state.module.id,
        id_live: coureur.id_live,
        dossard: coureur.dossard,
        type_bouton: "abandon",
        nouvelle_valeur: coureur.abandon,
      };
      axios.post(this.$store.state.base_url + "/pc_course/statut_coureur/post.php", data).then(function (response) {
        _this.fetchInscriptions();
      });
    },
    // Methode spécifique au PC course pour changer le statut de disqualification d'un coureur
    changeCoureurDisqualifie(coureur) {
      let _this = this;
      let data = {
        id_module: this.$store.state.module.id,
        id_live: coureur.id_live,
        dossard: coureur.dossard,
        type_bouton: "disqualifie",
        nouvelle_valeur: coureur.disqualifie,
      };

      axios.post(this.$store.state.base_url + "/pc_course/statut_coureur/post.php", data).then(function (response) {
        _this.fetchInscriptions();
      });
    },
    // Handler permet le raffraichissement automatique du tableau
    countdownRefresh() {
      if (!this.$store.state.live_en_cours) {
        this.$store.commit("clearRefreshIntervals");
        return;
      }
      var _this = this;
      var intervalObject = setInterval(function () {
        _this.$store.commit("clearRefreshIntervals");
        _this.fetchInscriptions();
      }, this.$store.state.refresh_time_live);
      this.$store.state.refreshIntervals.push(intervalObject);
    },
    // Charge la liste d'inscriptions
    fetchInscriptions() {
      var _this = this;
      if (this.$route.params.base === "BONETTE23") {
        this.view_adapter_BONETTE23();
      }
      if (this.$route.params.base === "MERIB22") {
        if (this.$store.state.selected_live_course === "CDF - Kilomètre vertical") {
          this.view_adapter_MERIB22_KV();
        } else {
          this.unset_view_adapter_MERIB22_KV();
        }
      }
      var endpoint = this.buildEndpoint();
      axios.get(this.$store.state.base_url + endpoint).then(function (response) {
        console.log("LIVE -- Fetch list participants ");
        _this.participants = response.data;
        if (_this.courseFilter === "") {
          // Si pas de course sélectionnée, par défaut la première
          _this.courseFilter = _this.participants.list_courses[0];
        }
        if (!_this.participants.list_courses.includes("Hors course")) {
          // Rajoute choix de course les hors courses
          _this.participants.list_courses.push("Hors course");
        }
        if (!_this.participants.list_parcours[_this.participants.list_courses[0]].live_en_cours) {
          // Check si live en cours
          _this.$store.state.live_en_cours = false;
        }
        if (parseInt(_this.participants.refresh_time_live) !== 0) {
          // Défini les durées de raffraichissement
          _this.$store.commit("set_refresh_time_live", _this.participants.refresh_time_live);
        }
        if (parseInt(_this.participants.refresh_time_carte) !== 0) {
          _this.$store.commit("set_refresh_time_carte", _this.participants.refresh_time_carte);
        }
        if (_this.participants.timestamp_depart) {
          // Données nécessaires au spinner_live pour afficher temps de course
          _this.$store.state.date_selected_course = _this.participants.timestamp_depart.date_course;
          _this.$store.state.heure_selected_course = _this.participants.timestamp_depart.heure_depart;
          _this.$store.state.fin_selected_course = _this.participants.timestamp_depart.course_finie;
        }

        _this.countdownRefresh();
        _this.$store.commit("unsetLoading");
      });
    },

    searchInscriptions() {
      if (this.searchFilter.length < 1) {
        this.searched_participants = this.participants.list_participants;
        return;
      }
      var _this = this;
      var endpoint = this.buildSearchEndpoint();
      axios.get(this.$store.state.base_url + endpoint).then(function (response) {
        console.log("LIVE -- Search participants ");
        _this.searched_participants = response.data.list_participants;
        _this.$store.commit("unsetLoading");
      });
    },

    buildSearchEndpoint() {
      var url = "/live/get.php?id=" + this.$store.state.module.id;

      if (this.searchFilter != "") {
        url += "&search=" + this.searchFilter;
      }

      return url;
    },

    buildEndpoint() {
      // Construit l'endpoint en fonction des filtres de l'utilisateur
      var url = "/live/get.php?id=" + this.$store.state.module.id;

      if (this.searchFilter != "") {
        url += "&search=" + this.searchFilter;
      }

      if (this.courseFilter != "") {
        url += "&course=" + encodeURIComponent(this.courseFilter);
      }
      if (this.sexeFilter != "") {
        url += "&sexe=" + this.sexeFilter;
      }
      if (this.sortby != "clt") {
        url += "&sortby=" + this.sortby;
      }
      url += "&page=" + (this.page - 1);
      return url;
    },

    get_translated_status(status) {
      // Ligne de statut retourné par le serveur en francais, traduit si langue locale = UK
      var translated = status;
      translated = translated.replace("Arrivée en", this.$t("arrivee_en"));
      translated = translated.replace("A l'entrainement", this.$t("entrainement"));
      translated = translated.replace("Non parti", this.$t("non_parti"));
      translated = translated.replace("Abandon", this.$t("abandon"));
      translated = translated.replace("Disqualifié", this.$t("disqualifie"));
      translated = translated.replace("A l'échauffement", this.$t("echauffement"));
      return translated;
    },
    view_adapter_pc_course() {
      // Si vue pc course, change les champs du tableau
      this.fields.splice(6, 1);
      let abandon_col = {
        key: "abandon",
        sortable: false,
        label: "Abandon",
      };
      let disqualifie_col = {
        key: "disqualifie",
        sortable: false,
        label: "Disqualifié",
      };
      this.fields.splice(this.fields.length - 1, 0, abandon_col, disqualifie_col);
    },
    view_adapter_MERIB22_KV() {
      // Si vue pc course, change les champs du tableau
      let heure_depart_col = {
        key: "heure_depart_coureur",
        sortable: false,
        label: "Heure départ",
      };

      this.fields.splice(this.fields.length - 1, 0, heure_depart_col);
    },
    unset_view_adapter_MERIB22_KV() {
      for (let i = 0; i < this.fields.length; i++) {
        if (this.fields[i].key === "heure_depart_coureur") {
          this.fields.splice(i, 1);
        }
      }
    },
    view_adapter_BONETTE23() {
      for (let i = 0; i < this.fields.length; i++) {
        if (this.fields[i].key === "cat") {
          this.fields.splice(i, 1);
        }
      }
    },
    row_femme(item, type) {
      if (!item || type !== "row") return;
      if (item.sexe === "F") return "row-femme";
    },
    openFicheCoureur(item, index) {
      var fiche_path = "fiche/" + item.id;
      this.$router.push({ path: fiche_path });
    },
  },
  created() {
    this.$store.commit("setLoading");
    this.$store.commit("clearRefreshIntervals");
    if (this.$route.params.course && this.$route.params.course != "") {
      this.courseFilter = this.$route.params.course;
      this.$store.state.selected_live_course = this.courseFilter;
    } else if (this.$store.state.selected_live_course && this.$store.state.selected_live_course != "") {
      this.courseFilter = this.$store.state.selected_live_course;
    }
    if (this.$store.state.logged) {
      this.view_adapter_pc_course();
    }

    this.fetchInscriptions();
    this.countdownRefresh();
  },
};
</script>

<style lang="sass" scoped>
</style>